import { Crf20222025 } from './Crf20222025';
import { Crf20262029 } from './Crf20262029';
import { CrfVersion } from './CrfVersion';
import { LegacyCrf } from './LegacyCrf';

export const crf20222025 = new Crf20222025();
export const crf20262029 = new Crf20262029();
export const legacyCrf = new LegacyCrf();

const REGISTRY: Record<string, CrfVersion> = {
  [crf20222025.code]: crf20222025,
  [crf20262029.code]: crf20262029,
};

const CRF_20222025_FROM = 2022;
export const CRF_20262029_FROM = 2026;

export function resolveCrf(code: string | null | undefined): CrfVersion {
  return (code && REGISTRY[code]) || legacyCrf;
}

export function resolveCrfByPeriod(
  period?: string | number | null,
): CrfVersion {
  if (period === null || period === undefined || period === '') {
    return legacyCrf;
  }

  const year = Number(period);
  if (!Number.isFinite(year)) return legacyCrf;
  if (year >= CRF_20262029_FROM) return crf20262029;
  if (year >= CRF_20222025_FROM) return crf20222025;
  return legacyCrf;
}
